import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=7275706a&scoped=true"
import script from "./table-header.vue?vue&type=script&lang=ts"
export * from "./table-header.vue?vue&type=script&lang=ts"
import style0 from "./table-header.vue?vue&type=style&index=0&id=7275706a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275706a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7275706a')) {
      api.createRecord('7275706a', component.options)
    } else {
      api.reload('7275706a', component.options)
    }
    module.hot.accept("./table-header.vue?vue&type=template&id=7275706a&scoped=true", function () {
      api.rerender('7275706a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/table/table-header.vue"
export default component.exports